import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    background-color: ${ props => props.bgColor ? props.bgColor : '#333333'};
    padding: 120px 0;
`;

export const PaddingWrapper = styled(Wrapper)`
    padding-top: ${p => p.nonTopPadding ? '0' : '120px'};
    padding-bottom: ${p => p.nonBottomPadding ? '0' : '120px'};
    @media (max-width: 640px) {
        padding: 50px 0 70px;
    }
`;

export const HeaderBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 45px;
    color: ${props => props.textColor ? props.textColor : COLORS.black};
    @media (max-width: 640px) {
        margin-bottom: 15px;
    }
`;

export const Title = styled.h2`
    font-weight: 300;
    line-height: 40px;
    font-size: 32px;
    margin-bottom: 35px;
    color: ${COLORS.black};
    @media (max-width: 768px) {
        font-family: 'Roboto Light',Arial,Helvetica,sans-serif;
        line-height: 32px;
        font-size: 24px;
    }
`;

export const TextDescription = styled.p`
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    color: ${COLORS.middleGray};
    @media (min-width: 1180px) {
        font-size: 16px;
        line-height: 24px;
    }
`;

export const ContentBlock = styled.div`
    width: 100%;
    background: ${COLORS.white};
    padding: 45px 65px 65px;
    color: ${COLORS.black};
    @media (max-width: 640px) {
        padding: 15px;
    }
`;

export const MainHeader = styled.h3`
    text-align: center;
    margin-bottom: 40px;
    font: 20px/32px ${FONTS.regular},Arial,Helvetica,sans-serif;
    @media (max-width: 640px) {
        margin-bottom: 15px;
    }
`;

export const MainContentUl = styled.ul`
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: column;
`;

export const Column = styled.div`
    display: flex;   
    flex-direction: column;
`;

export const ItemLi = styled.li`
    display: flex;   
    position: relative;
    line-height: 24px;
    margin-bottom: 20px;
    padding-left: 24px;
    flex: 1 2;
    @media (max-width: 640px) {
        width: 100%; 
    }
    &:before {
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        background-color: #000;
        top: 9px;
        left: 0;
        border-radius: 50%;
    }
`;

export const FooterBlock = styled.div`
    font: 14px/18px ${FONTS.light},Arial,Helvetica,sans-serif;
    padding: 25px 0px ;
    p {
        color: ${COLORS.middleGray};
    }
    @media (max-width: 640px) {
        padding-top: 0;
    }
`;

export const MainContainer = styled.div`
    display: block;
    max-width: calc(100% - 20px);
    width: 1360px;
    margin: 0 auto;
    @media(max-width: 1550px) {
        width: 1032px;
    }
    @media(max-width: 1240px) {
        width: 803px;
    }
    @media(max-width: 985px) {
        width: 700px;
    }
    @media(max-width: 720px) {
        width: calc(100% - 30px);
    }
`;
